const sections = ["latest", "videos", "sounds", "design"];
let currentIndex = 0;

function updateView() {
  const slider = document.querySelector(".project-slider");
  const label = sections[currentIndex] === "latest"
    ? "Latest"
    : sections[currentIndex].charAt(0).toUpperCase() + sections[currentIndex].slice(1);

  if (slider) {
    slider.style.transform = `translateX(-${currentIndex * 100}%)`;
    updateCategoryLabel(label);
  }

  const selectedLabel = document.querySelector(".selected-label");
  if (selectedLabel) {
    const textNode = selectedLabel.childNodes[0];
    if (textNode) {
      textNode.nodeValue = `[${label}] `;
    }
  }
}

function updateCategoryLabel(label) {
  const categoryEl = document.getElementById("project-category");
  if (!categoryEl) return;

  const dropdown = categoryEl.querySelector(".dropdown");
  const selectedLabel = dropdown?.querySelector(".selected-label");
  if (!selectedLabel) return;

  let i = 0;
  const interval = setInterval(() => {
    if (i <= label.length) {
      const partial = label.slice(0, i);
      selectedLabel.childNodes[0].nodeValue = `[${partial}] `;
      i++;
    } else {
      clearInterval(interval);
    }
  }, 30);
}

function detectSwipe() {
  let touchStartX = 0;
  let touchEndX = 0;

  document.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  document.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    if (touchEndX < touchStartX - 50) {
      currentIndex = (currentIndex + 1) % sections.length;
      updateView();
    } else if (touchEndX > touchStartX + 50) {
      currentIndex = (currentIndex - 1 + sections.length) % sections.length;
      updateView();
    }
  }
}

function initGalleries() {
  document.querySelectorAll(".project-gallery").forEach((gallery) => {
    const jsonEl = gallery.querySelector(".gallery-data");
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (err) {
      console.error("Invalid gallery JSON", err);
      return;
    }

    const img = gallery.querySelector(".gallery-image");
    const counter = gallery.querySelector(".gallery-counter");
    let index = 0;

    if (data.length > 0) {
      img.src = data[0].url;
      counter.textContent = `1 / ${data.length}`;
    }

    gallery.addEventListener("click", () => {
      if (!data || data.length === 0) return;
      index = (index + 1) % data.length;
      img.src = data[index].url;
      counter.textContent = `${index + 1} / ${data.length}`;
    });
  });
}

function initDropdown() {
  const dropdown = document.getElementById("category-dropdown");
  const selectedLabel = dropdown.querySelector(".selected-label");
  const arrow = selectedLabel.querySelector(".arrow");
  const listItems = dropdown.querySelectorAll("li");

  selectedLabel.addEventListener("click", () => {
    dropdown.classList.toggle("open");
  });

  listItems.forEach((item) => {
    item.addEventListener("click", () => {
      const index = parseInt(item.dataset.index);
      currentIndex = index;
      dropdown.classList.remove("open");
      updateView();
    });
  });

  document.addEventListener("click", (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  });
}

function glitchASCIIOnScroll() {
  const chars = "!@#$%^&*()_+-=[]{};:,.<>/?\\|~`";

  function scrambleText(el, original) {
    let iterations = 0;
    const maxIterations = 10;

    const scramble = () => {
      if (iterations >= maxIterations) {
        el.textContent = original;
        return;
      }

      const scrambled = original
        .split("")
        .map((char) => {
          if (char === "\n" || char === " ") return char;
          return Math.random() < 0.2
            ? chars[Math.floor(Math.random() * chars.length)]
            : char;
        })
        .join("");

      el.textContent = scrambled;
      iterations++;
      requestAnimationFrame(scramble); // faster and smoother than setTimeout
    };

    scramble();
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      if (entry.isIntersecting) {
        const original = el.dataset.original || el.textContent;
        el.dataset.original = original;

        if (!el.dataset.scrambling) {
          el.dataset.scrambling = "true";
          scrambleText(el, original);

          setTimeout(() => {
            el.dataset.scrambling = "";
          }, 1500); // allow retrigger soon after
        }
      }
    });
  }, {
    rootMargin: "0px 0px -20% 0px", // triggers earlier on scroll
    threshold: 0.1,
  });

  document.querySelectorAll(".ascii-skull pre").forEach((el) => {
    observer.observe(el);
  });
}



document.addEventListener("DOMContentLoaded", () => {
  detectSwipe();
  updateView();
  initGalleries();
  initDropdown();
  glitchASCIIOnScroll(); // scroll-based flicker trigger
});

